import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import store from '../../../../store';
import { IRootDispatch, RootState } from '../../../../store/models';
import { PublicProvider } from '../../../../api/Providers';
import { getIOSVersion, getIsApp } from '../../../../modules/AppInfo';
import {
  calculateSignupCountdownInfo,
  ProviderOnboardingStatus,
  SignupCountdownInfo,
} from '../../../../modules/api/providers/onboarding';

export function useSignupCountdownInfo(provider?: PublicProvider): SignupCountdownInfo {
  const dispatch = useDispatch<IRootDispatch>();

  const providerId = provider?.id;

  useEffect(() => {
    if (providerId) {
      dispatch.providerOnboarding.fetch(providerId);
    }
  }, [
    providerId,
    dispatch.providerOnboarding,
  ]);

  const onboardingStatus = useSelector<RootState, ProviderOnboardingStatus | undefined>(
    store.select.providerOnboarding.status({
      providerId,
      excludeSubscribeStep: !!(getIOSVersion() && getIsApp()),
    }),
  );

  return useMemo<SignupCountdownInfo>(() => (
    provider && onboardingStatus
      ? calculateSignupCountdownInfo(provider, onboardingStatus)
      : { showCountdown: false }
  ), [
    provider,
    onboardingStatus,
  ]);
}
